import { render, staticRenderFns } from "./FPrice.vue?vue&type=template&id=1db5b700&"
import script from "./FPrice.vue?vue&type=script&lang=js&"
export * from "./FPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports